import { format, formatCurrency, formatPercentage } from '../utils/Number';
import CalculatorLoan from './CalculatorLoan';

export default class CalculatorReko extends CalculatorLoan {
    constructor(element, options = {}) {
        super(element, {
            type: 'reko',
            tarif: 'U172',
            ...options,
        })

        this.isReady = false
    }

    prepare() {
        super.prepare()
        this.isReady = true
        this.duration = this.slideControls.maturity.element.querySelector('.RangeControl-input')
        this.loanOutput = this.slideControls.loan.element.querySelector('.RangeControl-input')
        this.paymentOutput = this.ref.duration
        this.slideControls.loan.on('change', this.update)
        this.update()
    }

    handleLoanChange = ({ value }) => {
        this.loanOutput.innerHTML = `<strong>${format(value)}</strong> Kč`
    }

    update = () => {
        if (!this.isReady) {
            return
        }

        const annuityData = this.annuityCalc()

        // marketingova akce
        if (annuityData.CC === 250000 && annuityData.delka === 240) {
            annuityData.splatkaPU = 1950
            annuityData.splatkaPUCelkem = 1950
        }

        const income = this.calcMinimalIncome({
            splatka: annuityData.splatkaPU,
            CC: annuityData.CC,
        })

        const data = {
            delka: annuityData.delka,
            sazbaPU: annuityData.sazba,
            income: income.income,
            splatka: annuityData.splatkaPU,
        }

        this.duration.innerHTML = this.formatOutput(data.delka)

        if (this.ref.income) {
            this.ref.income.innerHTML = formatCurrency(data.income)
        }

        if (this.ref.rate) {
            this.ref.rate.innerHTML = formatPercentage(data.sazbaPU)
        }

        this.paymentOutput.innerHTML = formatCurrency(data.splatka)

        if (window.dataLayer) {
            dataLayer.push({
                kalkulacka_vyseUveru: `${data.uver}`,
                kalkulacka_dobaSplaceni: `${data.delka}`,
                kalkulacka_mesicniSplatka: `${data.uzivatelskaSplatkaPU}`,
                event: 'kalkulacka_changeValue',
            })
        }
    }

    formatOutput(duration) {
        let years = Math.floor(duration / 12)
        let months = duration % 12

        let output = ''

        if (years === 1) {
            output = '<strong>1</strong> rok'
        } else if (years > 4) {
            output = '<strong>' + years + '</strong> let'
        } else {
            output = '<strong>' + years + '</strong> roky'
        }

        if (months > 0) {
            output +=
                ' a <strong>' +
                months +
                '</strong> ' +
                (months == 1 ? 'měsíc' : months < 5 ? 'měsíce' : 'měsíců')
        }

        return output
    }

    getData() {
        const data = super.getData()

        const duration = this.duration.innerText
        data.loan.parsed = `${data.loan.label} ${formatCurrency(data.loan.value)}`
        if (data.payment) {
            data.payment.parsed = `${data.payment?.label} ${duration}`
        }

        return data
    }
}
